module.exports = __webpack_public_path__ + "img/img1.2e0645c3.png";